/* eslint-disable */
import React, { useState, useEffect } from 'react';

import Analyze from './Analyze';
import styles from './App.module.scss';
import Merge from './Merge';
import { root, system } from './apis';

//import { SysInfoDTO } from 'orbus-uploader-client';
import io from 'socket.io-client';

function isDevMode() {
	return '_self' in React.createElement('div');
}

const devMode = isDevMode();

const socket = io(root, {
	path: '/api/events',
	forceNew: true,
	// create-react-app dev mode socket conflicts with socket.io,
	// so we can only use websockets in production
	extraHeaders: {
		'x-uploader-key': process.env?.REACT_APP_API_KEY || ''
	},
	transports: devMode ? ['polling'] : ['polling', 'websocket']
});

export default function App() {
	/* eslint-disable */
	const [sysInfo, setSysInfo] = useState<any>();

	useEffect(() => {
		/* eslint-disable */
		void system.getSystemInfo().then(setSysInfo);
	}, []);

	return (
		<>
			<h1 className={styles.Header}>Artwork Uploader Testing UI</h1>
			<p style={{ textAlign: 'center' }}>
				This is an MVP UI for internal testing/demo purposes only.
			</p>
			<h2 className={styles.Header}>Analyze</h2>
			<Analyze socket={socket} />
			<h2 className={styles.Header}>Merge</h2>
			<Merge socket={socket} />
			<p style={{ textAlign: 'center' }}>
				{sysInfo
					? `artwork uploader version ${sysInfo.commitId}`
					: 'Loading system information'}
			</p>
		</>
	);
}
